import useGetSearchResultsBound from "../../../hooks/useGetSearchResultsBound";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getSearchType } from "../../../store/search/selectors";
import { getSearchResultsCampaignBanner, getSearchResultsRemoteBanners } from "../../../store/searchResults/selectors";
import {
  getSearchResultsCampaignBanner as getOBSearchResultsCampaignBanner,
  getSearchResultsRemoteBanners as getOBSearchResultsRemoteBanners
} from "../../../store/searchResultsBounds/outboundSelectors";
import {
  getSearchResultsCampaignBanner as getIBSearchResultsCampaignBanner,
  getSearchResultsRemoteBanners as getIBSearchResultsRemoteBanners
} from "../../../store/searchResultsBounds/inboundSelectors";
import { useTrackSplitBoundsStages } from "../../../utils/experiments/funnel/flights_split_bounds_us";

const useSearchResultsListDesktopController = () => {
  const bound = useGetSearchResultsBound();
  const boundSelectors = useMemo(() => {
    if (bound === "outbound") {
      return {
        campaignBanner: getOBSearchResultsCampaignBanner,
        remoteBanners: getOBSearchResultsRemoteBanners
      };
    }
    if (bound === "inbound") {
      return {
        campaignBanner: getIBSearchResultsCampaignBanner,
        remoteBanners: getIBSearchResultsRemoteBanners
      };
    }
    return {
      campaignBanner: getSearchResultsCampaignBanner,
      remoteBanners: getSearchResultsRemoteBanners
    };
  }, [bound]);

  const searchType = useSelector(getSearchType);
  const campaignBanner = useSelector(boundSelectors.campaignBanner);
  const remoteBanners = useSelector(boundSelectors.remoteBanners);

  /* start - flights_split_bounds_us */
  useTrackSplitBoundsStages();
  /* end - flights_split_bounds_us */

  return {
    searchType,
    campaignBanner,
    remoteBanners
  };
};

export default useSearchResultsListDesktopController;
